import { autoinject, TemplatingEngine, View, ViewResources } from 'aurelia-framework';

/**
 * Duplicates the bound Element value in the place of the current element with the current binding context.
 * @note This allows for creating a live template element and duplicating it
 *  anywhere with a new binding context. This is useful for features like
 *  live previews. It is also used by the dynamic grid to transform developer
 *  written templates into live grid cells.
 * @bindable {Element} value - The Element to duplicate.
 */
@autoinject()
export class DuplicateCustomAttribute {

    protected value: Element | null = null;
    protected currentElement: Element | null = null;
    protected currentView: View | null = null;

    protected parentView!: View & { resources: ViewResources };
    protected bindingContext!: any;
    protected overrideContext!: any;

    constructor(protected element: Element, protected engine: TemplatingEngine) { }

    protected created(owningView: View & { resources: ViewResources }) {
        this.parentView = owningView;
    }

    protected bind(bindingContext: any, overrideContext: any) {
        this.bindingContext = bindingContext;
        this.overrideContext = overrideContext;
        this.valueChanged(this.value);
    }

    protected detached() {
        if(this.currentView) {
            this.currentView.detached();
        }
    }

    protected unbind() {
        if(this.currentView) {
            this.currentView.unbind();
        }
    }

    protected valueChanged(value: Element | null) {
        if(this.currentElement) {
            this.currentElement.remove();
            this.currentElement = null;
        }
        if(this.currentView) {
            this.currentView.detached();
            this.currentView.unbind();
        }
        if(value !== null) {
            const { container, resources, bindingContext, overrideContext } = this.parentView;
            const element = value.cloneNode(true) as Element;
            this.currentView = this.engine.enhance({ element, container, resources, bindingContext, overrideContext });
            this.currentElement = this.element.appendChild(element);
        }
    }
}
